import PhoneCallIcon from '../Icons/PhoneCallIcon';

const OfferHelp = ({ className }: { className?: string }) => {
    return (
        <div
            className={`${className} bg-white rounded-lg flex justify-center w-full py-5 lg:hidden`}
        >
            <div className='items-center'>
                <div className='flex'>
                    <PhoneCallIcon />
                    <p className='font-bold pl-2 text-md'>Need help?</p>
                </div>
                <p className='text-md pl-6'>
                    020 4525 8044 (Mon - Fri, 9am - 5pm)
                </p>
            </div>
        </div>
    );
};

export default OfferHelp;
